import axios from 'axios'
import baseService from './baseService'

const appraisalService = {
  getUserAuthenticationToken (code, state) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve()
      } else {
        axios
          .get('carfax/getUserAuthenticationToken', { params: { code: code, state: state } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  }
}

export default appraisalService
